import { Injectable, Inject } from "@angular/core";
import { ShaderType, compileShader } from "./shader-source";
import { Uint32 } from "../game-engine/uint32";
import { Float32 } from "../game-engine/float32";
import { WEBGL2, GLSL_VERSION, SHADER_DEFINITIONS } from "../webgl2/webgl2-token";
var ShaderProgram = (function () {
    function ShaderProgram(gl, glsl_version_, shader_definitions, vertex_shader_source, fragment_shader_source) {
        this.gl = gl;
        this.glsl_version_ = glsl_version_;
        this.shader_definitions = shader_definitions;
        this.vertex_shader_source = vertex_shader_source;
        this.fragment_shader_source = fragment_shader_source;
        this.uniforms_ = new Map();
    }
    Object.defineProperty(ShaderProgram.prototype, "uniform_map", {
        get: function () { return this.uniforms_; },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    ShaderProgram.prototype.deleteProgram = function () {
        this.gl.deleteProgram(this.program_);
    };
    ;
    ShaderProgram.prototype.getUniform = function (name) {
        return this.uniforms_.get(name);
    };
    ;
    ShaderProgram.prototype.setUniform = function (uniform_name, uniform_value) {
        var uniform_location = this.getUniform(uniform_name);
        if (typeof uniform_value === "boolean") {
            var int = uniform_value ? 1 : 0;
            this.gl.uniform1ui(uniform_location, int);
        }
        else {
            var size = uniform_value.length;
            switch (size) {
                case 1:
                    if (uniform_value instanceof Uint32) {
                        this.gl.uniform1ui(uniform_location, uniform_value.value);
                    }
                    else if (uniform_value instanceof Float32) {
                        this.gl.uniform1f(uniform_location, uniform_value.value);
                    }
                    else {
                        this.gl.uniform1fv(uniform_location, uniform_value);
                    }
                    break;
                case 3:
                    var array_3f = uniform_value.array || uniform_value;
                    this.gl.uniform3fv(uniform_location, array_3f);
                    break;
                case 4:
                    var array_4f = uniform_value.array || uniform_value;
                    this.gl.uniform4fv(uniform_location, array_4f);
                    break;
                case 16:
                    this.gl.uniformMatrix4fv(uniform_location, false, uniform_value.array);
                    break;
                default:
                    console.log("Invalid uniform: " + uniform_name + ", size: " + size + ", uniform_value: " + uniform_value + ".");
            }
        }
    };
    ;
    ShaderProgram.prototype.initProgram = function () {
        var vertex_shader = compileShader(this.gl, ShaderType.Vertex, this.vertex_shader_source.source, this.glsl_version_, this.shader_definitions);
        var fragment_shader = compileShader(this.gl, ShaderType.Fragment, this.fragment_shader_source.source, this.glsl_version_, this.shader_definitions);
        this.program_ = this.gl.createProgram();
        this.gl.attachShader(this.program_, vertex_shader);
        this.gl.attachShader(this.program_, fragment_shader);
        this.gl.linkProgram(this.program_);
        if (!this.gl.getProgramParameter(this.program_, this.gl.LINK_STATUS)) {
            console.log("Program link error: " + this.gl.getProgramInfoLog(this.program_));
            this.gl.deleteProgram(this.program_);
            this.gl.deleteShader(vertex_shader);
            this.gl.deleteShader(fragment_shader);
            alert("Unable to initialize the shader program.");
        }
        else {
            this.gl.detachShader(this.program_, vertex_shader);
            this.gl.detachShader(this.program_, fragment_shader);
            this.gl.deleteShader(vertex_shader);
            this.gl.deleteShader(fragment_shader);
            this.locateUniforms(this.gl);
        }
    };
    ;
    ShaderProgram.prototype.useProgram = function () {
        this.gl.useProgram(this.program_);
    };
    ;
    ShaderProgram.prototype.locateUniforms = function (gl) {
        var _this = this;
        this.vertex_shader_source.uniforms.forEach(function (uniform_name) {
            var uniform_location = _this.gl.getUniformLocation(_this.program_, uniform_name);
            _this.uniforms_.set(uniform_name, uniform_location);
        });
        this.fragment_shader_source.uniforms.forEach(function (uniform_name) {
            var uniform_location = _this.gl.getUniformLocation(_this.program_, uniform_name);
            _this.uniforms_.set(uniform_name, uniform_location);
        });
    };
    ;
    ShaderProgram.decorators = [
        { type: Injectable },
    ];
    ShaderProgram.ctorParameters = function () { return [
        { type: WebGL2RenderingContext, decorators: [{ type: Inject, args: [WEBGL2,] },] },
        { type: undefined, decorators: [{ type: Inject, args: [GLSL_VERSION,] },] },
        { type: Array, decorators: [{ type: Inject, args: [SHADER_DEFINITIONS,] },] },
        null,
        null,
    ]; };
    return ShaderProgram;
}());
export { ShaderProgram };
//# sourceMappingURL=shader-program.js.map